module.exports = __webpack_public_path__ + "static/media/greentick.8eac24f1.png";